module.exports = __webpack_public_path__ + "img/file-richtext-fill.a7693fb7.svg";